<button
  *transloco="let t"
  appearance="flat"
  class="relative -top-0.5 -my-1 bg-background-success-primary! text-text-success-primary! hover:bg-background-success-secondary!"
  data-testid="patient-quick-action"
  iconStart="@tui.link"
  size="xs"
  tuiHintDirection="end"
  tuiIconButton
  type="button"
  [tuiHint]="t('Le patient est rattaché à votre établissement.')"></button>
